package com.ilussobsa.views

import com.ilussobsa.Strings
import com.ilussobsa.sdk.currentSession
import com.lightningkite.UUID
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.pageNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.ViewModifiable
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*

@Routable("vehicle/{id}")
class VehicleDetailScreen(val id: UUID): Page {
    var gotoOverride: (suspend (UUID?)->Unit)? = null
    override val title: Reactive<String> = remember { currentSession().vehicle[id]()?.mmt ?: Strings.vehicleDetail }
    override fun ViewWriter.render(): ViewModifiable {
      return vehicleDetail(id, goto = {
            gotoOverride?.invoke(it) ?: if(it != null) pageNavigator.replace(VehicleDetailScreen(it)) else null
        }, backButtonInfo = null)
    }
}